
import { Vue } from "vue-class-component";

export default class DownloadUnderscore extends Vue {}
